var _defs, _rect, _use, _use2, _use3, _use4, _use5, _use6, _use7, _rect2, _use8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAmericanFlag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1235 650",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "pt",
    points: "-0.1624598481164531,0 0,-0.5 0.1624598481164531,0",
    transform: "scale(0.0616)",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "star"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pt",
    transform: "rotate(-144)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pt",
    transform: "rotate(-72)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pt"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pt",
    transform: "rotate(72)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pt",
    transform: "rotate(144)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "s5"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#star",
    x: -0.252
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#star",
    x: -0.126
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#star"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#star",
    x: 0.126
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#star",
    x: 0.252
  })), /*#__PURE__*/React.createElement("g", {
    id: "s6"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s5",
    x: -0.063
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#star",
    x: 0.315
  })), /*#__PURE__*/React.createElement("g", {
    id: "x4"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s6"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s5",
    y: 0.054
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s6",
    y: 0.108
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s5",
    y: 0.162
  })), /*#__PURE__*/React.createElement("g", {
    id: "u"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#x4",
    y: -0.216
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#x4"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s6",
    y: 0.216
  })), /*#__PURE__*/React.createElement("rect", {
    id: "stripe",
    width: 1235,
    height: 50,
    fill: "#B22234"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1235,
    height: 650,
    fill: "#FFF"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stripe"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stripe",
    y: 100
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stripe",
    y: 200
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stripe",
    y: 300
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stripe",
    y: 400
  })), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stripe",
    y: 500
  })), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stripe",
    y: 600
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 494,
    height: 350,
    fill: "#3C3B6E"
  })), _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#u",
    transform: "translate(247,175) scale(650)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmericanFlag);
export default __webpack_public_path__ + "static/media/american_flag.1f7db5b5.svg";
export { ForwardRef as ReactComponent };